$('.click--down').click(function(){
    if ($(this).hasClass('down')) {
        $(this).parent().find(".accordion--slide").slideDown();
        $(this).addClass("up").removeClass("down");
    } else {
        $(this).parent().find(".accordion--slide").slideUp();
            $(this).addClass("down").removeClass("up");
    }
})



$('.tab--link').click(function () {
    var tabID = $(this).attr('data-tab');

    $(this).addClass('active').siblings().removeClass('active');

    $('#tab-' + tabID)
        .addClass('active')
        .siblings()
        .removeClass('active');
});

// Optionaler Arrow-Link: Navigation nicht durch Tab-Switch blockieren / mitauslösen.
$('.tab--link .svg--round--arrow').on('click', function (e) {
    e.stopPropagation();
});